/* eslint-disable prettier/prettier */
import Axios from "axios";

import {
  SET_LOGGED_IN,
  UNSET_LOGGED_IN,
  SET_AUTH_USER,
  UNSET_AUTH_USER,
  SET_USER_TOKEN,
  UNSET_USER_TOKEN,
  SET_LOGGEDIN_EXAM,
  SET_LOGGEDIN_DEGREE,
  SET_LOGGEDIN_YEAR,
  SET_LOGGEDIN_EXAM_NAME,
  UNSET_ALL_LOGIN_STATE,
  SET_EXAM_INITIATE_ID,
  SET_LOGGEDIN_EXAM_TYPE,
  SET_ASSIGNED_EXAMS,
  SET_CURRENT_CENTER_AS_ALLOC,
  UNSET_CURRENT_CENTER_AS_ALLOC,
  SET_CORRECT_CENTER_STATUS,
  UNSET_CORRECT_CENTER_STATUS,
  GET_ERROR_LOG_MSG,
} from "../mutation-types";

import { loginUrl, centerAllocCentersApi } from "../api";
// import {
//   failedMsg, loadMsg, saveMsg, updateMsg, deleteMsg
// } from '../erpUtil'

// initial state
const state = {
  errorLogMsg: {},
  loggedIn: false,
  loggedInExam: {
    code: "",
  },
  loggedInDegree: {
    code: "",
  },
  loggedInYear: {
    year: "",
  },
  userToken: "",
  authUser: {},
  response: "",
  exam_initiate_id: 1,
  loggedInExamType: 1,
  assignedExamList: [],
  centerAsAlloc: {},
  correctCenterStatus: true,
  loggedInExamName: {
    exam_name: "",
  },
  // authUserType: JSON.parse(localStorage.getItem("user")).type || ""
};
const getters = {
  getLoggedIn(state) {
    return state.loggedIn;
  },

  getErrorLog(state) {
    return state.errorLogMsg; 
  },

  getAuthUser(state) {
    // console.log("getAuthUser", state.authUser);
    return state.authUser;
  },

  getAuthUserID(state) {
    return state.authUser.id;
  },
  getAuthUserExamInitiates(state) {
    return state.authUser.exam_initiates;
  },
  getAuthUserType(state, getters) {
    // console.log("user in getAuthUserType", state.user);
    return state.authUser.type;
  },
  getAuthUserTypeID(state) {
    // console.log("am I here ??  --- >");
    let user = state.authUser;
    let type = "~";
    switch (parseInt(user.type)) {
      case 1:
        type = "admin";
        break;
      case 2:
        type = "center";
        break;
      case 3:
        type = "regional_center";
        break;
      case 4:
        type = "invigilator";
        break;
      case 5:
        type = "examiner";
        break;
      case 6:
        type = "nu";
        break;
      case 7:
        type = "rescrutiner";
        break;
      case 8:
        type = "programmer";
        break;
      case 9:
        type = "ict_director";
        break;
      case 10:
        type = "controller";
        break;
      case 11:
        type = "vc";
        break;
      case 12:
        type = "pro_vc";
        break;
    }
    // console.log("type  --- >", type);
    // console.log("user[type].id  --- >", user[type].id);
    return user[type].id;
  },
  //exam and year
  getLoggedInExam(state) {
    return state.loggedInExam;
  },
  getLoggedInDegree(state) {
    return state.loggedInDegree;
  },
  getLoggedInYear(state) {
    return state.loggedInYear;
  },
  getLoggedIneExamName(state) {
    return state.loggedInExamName;
  },
  getExamInitiateId(state) {
    return state.exam_initiate_id;
  },
  getLoggedInExamType(state) {
    return state.loggedInExamType;
  },
  getAssignedExamList(state) {
    return state.assignedExamList;
  },
  getCenterAsAlloc(state) {
    return state.centerAsAlloc;
  },
  getCorrectCenterStatus(state) {
    return state.correctCenterStatus;
  },
};
// mutations
const mutations = {
  [GET_ERROR_LOG_MSG](state, errorLogMsg) {
    state.errorLogMsg = errorLogMsg;
  },
  [SET_LOGGED_IN](state) {
    state.loggedIn = true;
  },
  [UNSET_LOGGED_IN](state) {
    state.loggedIn = false;
  },
  [SET_USER_TOKEN](state, token) {
    state.userToken = token;
  },
  [UNSET_USER_TOKEN](state) {
    state.userToken = "";
  },
  [SET_AUTH_USER](state, authuser) {
    state.authUser = authuser;
  },
  [UNSET_AUTH_USER](state) {
    state.authUser = {
      password: "",
      email: "",
    };
  },

  [UNSET_ALL_LOGIN_STATE](state) {
    state.loggedIn = false;
    state.loggedInExam = {
      code: "",
    };
    state.loggedInDegree = {
      code: "",
    };
    state.loggedInYear = {
      year: "",
    };
    state.userToken = "";
    state.authUser = {};
  },
  //
  [SET_LOGGEDIN_EXAM](state, loggedInExam) {
    // console.log("SP: ***** am I here");
    localStorage.setItem("loggedInExam", JSON.stringify(loggedInExam));
    state.loggedInExam = loggedInExam;
  },
  [SET_LOGGEDIN_DEGREE](state, loggedInDegree) {
    // console.log("SP: ***** am I here");
    localStorage.setItem("loggedInDegree", JSON.stringify(loggedInDegree));
    state.loggedInDegree = loggedInDegree;
  },
  [SET_LOGGEDIN_YEAR](state, loggedInYear) {
    localStorage.setItem("loggedInYear", JSON.stringify(loggedInYear));
    state.loggedInYear = loggedInYear;
  },
  [SET_LOGGEDIN_EXAM_NAME](state, loggedInExamName) {
    localStorage.setItem("loggedInExamName", JSON.stringify(loggedInExamName));
    state.loggedInExamName = loggedInExamName;
    // console.log("loggedInExamName",loggedInExamName.exam_name);
  },

  [SET_EXAM_INITIATE_ID](state, exam_initiate_id) {
    state.exam_initiate_id = exam_initiate_id;
    // console.log("ini id ",exam_initiate_id)
  },

  [SET_LOGGEDIN_EXAM_TYPE](state, type) {
    state.loggedInExamType = type;
  },
  [SET_ASSIGNED_EXAMS](state, exams) {
    state.assignedExamList = exams;
  },
  [SET_CURRENT_CENTER_AS_ALLOC](state, data) {
    state.centerAsAlloc = data;
  },
  [UNSET_CURRENT_CENTER_AS_ALLOC](state, data) {
    state.centerAsAlloc = {};
  },
  [SET_CORRECT_CENTER_STATUS](state) {
    state.correctCenterStatus = true;
  },
  [UNSET_CORRECT_CENTER_STATUS](state) {
    state.correctCenterStatus = false;
  },
};
// Actions
const actions = {
  // authenticateUser({ commit, state }, authUser) {
  //   var params = new URLSearchParams();
  //   params.append("email", authUser.email);
  //   params.append("password", authUser.password);
  //    params.append("captcha_answer", authUser.captcha);
  //   params.append("captcha_key", authUser.key);
  //   commit("SET_LOADING", {
  //     color: "primary",
  //   });
  //   return new Promise((resolve, reject) => {
  //     Axios.post(loginUrl, params)
  //       .then(function(response) {
  //         commit("UNSET_LOADING"); 
  //         var token = response.data.token;
  //         var expires = response.data.expires;
  //         var user = response.data.user;
  //         var exams = response.data.exams;
  //         var menu = response.data.menu;

  //         if (parseInt(user.type) === 1) {
  //           user.admin = {
  //             id: 1,
  //           };
  //         }
  //         localStorage.setItem("guard", true);
  //         localStorage.setItem("token", token);
  //         localStorage.setItem("user", JSON.stringify(user));

  //         localStorage.setItem("exams", JSON.stringify(exams));

  //         localStorage.setItem("menu", JSON.stringify(menu));
  //         commit("SET_LOGGED_IN");
  //         commit("SET_AUTH_USER", user);
  //         commit("SET_USER_TOKEN", token);

  //         try {
  //           commit("SET_ASSIGNED_EXAMS", exams);


  //           if (user.exam_initiates.length > 0) {

  //             commit("SET_LOGGEDIN_EXAM", {
  //               code: user.exam_initiates[0].exam_code,

  //             });
  //             commit("SET_LOGGEDIN_DEGREE", {
  //               code: user.exam_initiates[0].exam.degree_code,
  //             });
  //             commit("SET_LOGGEDIN_YEAR", {
  //               year: user.exam_initiates[0].exam_year,
  //             });
  //             commit("SET_LOGGEDIN_EXAM_NAME", {
  //               exam_name: user.exam_initiates[0].exam_name,
  //             });
  //             commit("SET_EXAM_INITIATE_ID", user.exam_initiates[0].id);
  //             commit(
  //               "SET_LOGGEDIN_EXAM_TYPE",
  //               parseInt(user.exam_initiates[0].exam_type)
  //             );

  //           } else {
  //             commit("SET_LOGGEDIN_YEAR", {
  //               year: "",
  //             });
  //             commit("SET_LOGGEDIN_DEGREE", {
  //               code: "",
  //             });
  //             commit("SET_LOGGEDIN_EXAM", {
  //               code: "",
  //             });
  //           }
  //         } catch (ex) {
  //           console.log("EDD", ex);
  //         }

  //         resolve();
  //       })
  //       .catch(function(error) {
  //         console.log("error", error);
  //         localStorage.setItem("token", "");
  //         localStorage.setItem("expires", "");

  //         commit("UNSET_LOGGED_IN");
  //         commit("UNSET_AUTH_USER");
  //         commit("UNSET_USER_TOKEN");

  //         reject();
  //       });
  //   });
  // },
  authenticateUser({ commit, state }, authUser) {
    var params = new URLSearchParams();
    params.append("email", authUser.email);
    params.append("password", authUser.password);
    params.append("captcha_answer", authUser.captcha);
    params.append("captcha_key", authUser.key);

    commit("SET_LOADING", {
      color: "primary",
    });

    return new Promise((resolve, reject) => {
      Axios.post(loginUrl, params, {
        validateStatus: function () {
          return true; // always go to then()
        },
      })
        .then(function (response) {
          commit("UNSET_LOADING");
          console.log("LOGIN RESPONSE:", response.data);
          var data = response.data;
          var isError =
            (data && data.success && data.success === "error") ||
            (response.status !== 200);

          if (isError) {
            commit('GET_ERROR_LOG_MSG', data || "Login failed");
            var msg = "Login failed";

            if (data && data.message) {
              msg = data.message;
            }
            if (data && data.errors) {
              msg = Object.values(data.errors)[0][0];
            }

            commit("SET_SNACKBAR", {
              msg: msg,
              color: "red",
            });

            reject(response);
            return;
          }
          var token = data.token;
          var expires = data.expires;
          var user = data.user;
          var exams = data.exams;
          var menu = data.menu;

          if (parseInt(user.type) === 1) {
            user.admin = { id: 1 };
          }
          localStorage.setItem("guard", true);
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("exams", JSON.stringify(exams));
          localStorage.setItem("menu", JSON.stringify(menu));
          commit("SET_LOGGED_IN");
          commit("SET_AUTH_USER", user);
          commit("SET_USER_TOKEN", token);
          commit("SET_SNACKBAR", {
            msg: data.message || "Login successful",
            color: "green",
          });
          try {
            commit("SET_ASSIGNED_EXAMS", exams);

            if (user.exam_initiates && user.exam_initiates.length > 0) {
              commit("SET_LOGGEDIN_EXAM", {
                code: user.exam_initiates[0].exam_code,
              });

              commit("SET_LOGGEDIN_DEGREE", {
                code: user.exam_initiates[0].exam.degree_code,
              });

              commit("SET_LOGGEDIN_YEAR", {
                year: user.exam_initiates[0].exam_year,
              });

              commit("SET_LOGGEDIN_EXAM_NAME", {
                exam_name: user.exam_initiates[0].exam_name,
              });

              commit("SET_EXAM_INITIATE_ID", user.exam_initiates[0].id);

              commit(
                "SET_LOGGEDIN_EXAM_TYPE",
                parseInt(user.exam_initiates[0].exam_type)
              );
            } else {
              commit("SET_LOGGEDIN_YEAR", { year: "" });
              commit("SET_LOGGEDIN_DEGREE", { code: "" });
              commit("SET_LOGGEDIN_EXAM", { code: "" });
            }
          } catch (ex) {
            console.log("EXCEPTION:", ex);
          }

          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LOADING");

          var msg = "Network error occurred";

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red",
          });

          reject(error);
        });
    });
  },
  logoutUser({ commit, state }) {
    return new Promise((resolve) => {
      localStorage.setItem("token", "");
      localStorage.setItem("expires", "");
      localStorage.setItem("menu", "");
      localStorage.setItem("user", "");
      localStorage.setItem("guard", "");
      localStorage.setItem("exams", "");
      localStorage.clear();
      // commit("UNSET_LOGGED_IN");
      // commit("UNSET_AUTH_USER");
      // commit("UNSET_USER_TOKEN");
      commit("UN_SET_EXAM_DATA");
      commit("UN_SET_ALL_YEARS");
      commit("UNSET_ALL_LOGIN_STATE");
      commit("UNSET_ALL_STUDENT_LIST_DATA");

      resolve();
    });
  },
  getAuthUserTypeID({ commit }) {
    return new Promise((resolve) => {
      // console.log("am I here ??  --- >");
      let user = JSON.parse(localStorage.getItem("user"));
      let type = "~";
      switch (parseInt(user.type)) {
        case 1:
          type = "admin";
          break;
        case 2:
          type = "center";
          break;
        case 3:
          type = "regional_center";
          break;
        case 4:
          type = "invigilator";
          break;
        case 5:
          type = "examiner";
          break;
        case 6:
          type = "nu";
          break;
        case 7:
          type = "rescrutiner";
          break;
        case 8:
          type = "programmer";
          break;
        case 9:
          type = "ict_director";
          break;
        case 10:
          type = "controller";
          break;
        case 11:
          type = "vc";
          break;
        case 12:
          type = "pro_vc";
          break;
        case 21:
          type = "examiner";
          break;
        case 22:
          type = "systemanalyst";
          break;
      }
      // console.log("type  --- >", type);
      //console.log('user[type].id  --- >', user[type].id);
      // if (user.id == 29) {
      //     resolve(user.id);
      // }
      console.log("...m", user);
      resolve(user[type].id);
    });
  },
  getAuthUserType({ commit }) {
    return new Promise((resolve) => {
      // console.log("am I here ??  --- >");
      let user = JSON.parse(localStorage.getItem("user"));
      console.log("...", user.type);
      resolve(parseInt(user.type));
    });
  },

  setCorrectCenter({ commit, state }, payload) {
    if (payload.type == 1) {
      payload.type = '';
    }
    // console.log("payload +-+-+ :: ac", payload);
    return new Promise(function (resolve, reject) {
      Axios.get(centerAllocCentersApi, {
        params: payload,
      })
        .then(function (response) {
          try {
            // console.log(" here sp here: ", response.data.data);
            var result = response.data.data;
            state.authUser.center.center_code = -1;
            state.authUser.center.practical_center_code = -1;
            state.authUser.center.viva_center_code = -1;
            // commit("SET_CURRENT_CENTER_AS_ALLOC", result);
            // console.log("response--", result);
            // console.log("state.authUser::", state.authUser);
            if (response.data.data.length != 0) {
              result.forEach((ele) => {
                if (response.data.data.length == 2) {
                  //parseInt(ele.type) == 1 (Previous logic)
                  //console.log("in 1", result);
                  result.forEach((resp) => {
                    //console.log("Tanvir this is resp array", resp);
                    if (resp.type == 1) {
                      state.authUser.center.center_code = resp.center_code;
                      // console.log("Tanvir this is center_code", state.authUser.center.center_code);
                    }
                    if (resp.type == 2) {
                      state.authUser.center.practical_center_code = resp.center_code;
                      // console.log("Tanvir this is practical_center_code", state.authUser.center.practical_center_code);
                    }
                  });
                  //state.authUser.center.center_code = ele.center_code;
                  // console.log("1.state.authUser", state.authUser);
                  localStorage.setItem("user", JSON.stringify(state.authUser));
                }
                if (response.data.data.length == 1) {
                  //parseInt(ele.type) == 2 (Previous logic)
                  //console.log("in 2");
                  state.authUser.center.practical_center_code = ele.center_code;
                  state.authUser.center.center_code = ele.center_code; //temporary solution
                  //  console.log("2.state.authUser", state.authUser);
                  localStorage.setItem("user", JSON.stringify(state.authUser));
                }
                if (parseInt(ele.type) == 3) {
                  // console.log("in 3");
                  state.authUser.center.viva_center_code = ele.center_code;
                  // console.log("3.state.authUser", state.authUser);
                  localStorage.setItem("user", JSON.stringify(state.authUser));
                }
              });
            } else {
              state.authUser.center.center_code = -1;
              state.authUser.center.practical_center_code = -1;
              state.authUser.center.viva_center_code = -1;
              localStorage.setItem("user", JSON.stringify(state.authUser));
            }

            console.log("state.authUser::", state.authUser);
          } catch (er) {
            console.log("error in setCorrectCenter");
          }

          resolve();
        })
        .catch(function (error) {
          // handle error
          //   console.log(error);
          state.authUser.center.center_code = -1;
          state.authUser.center.practical_center_code = -1;
          state.authUser.center.viva_center_code = -1;
          localStorage.setItem("user", JSON.stringify(state.authUser));
          // console.log("state.authUser::", state.authUser);
          reject();
        });
    });
  },

  // exam
};

export default {
  state,
  getters,
  actions,
  mutations,
};
